import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow'
import { MbonusLineBeket } from 'shared/ui/beket/mbonus-line-beket'
import { Button } from 'shared/ui/button'
import { CheckBox } from 'shared/ui/check-box'

import s from './styles.module.scss'

interface Props {
  count?: number
  price?: string
  bonus?: string | undefined
  onSubmit?: () => void
  onShowDocument?: () => void
}

export const PayButton = ({
  count,
  price,
  onSubmit,
  onShowDocument,
  bonus,
}: Props) => {
  const { t } = useTranslation()

  const [isConfirm, setIsConfirm] = useState<boolean>(!Boolean(onShowDocument))
  return (
    <>
      <div className={s.wrapper} />
      <div className={s.container}>
        <div className={s.infoWrapper}>
          <div className={s.priceWrapper}>
            <p className={s.text}>
              {t('purchase_page.price_for_passengers', { count: count })}
            </p>

            <p className={clsx('bold-18', s.price)}>
              {priceShow(price)} &#8384;
            </p>
          </div>

          {bonus && <MbonusLineBeket bonus={bonus} />}
        </div>

        {onShowDocument && (
          <div className={s.confirmCheck}>
            <CheckBox
              isChecked={isConfirm}
              onClick={() => {
                setIsConfirm(!isConfirm)
              }}
            />

            <p className={clsx(s.textBlock, 'regular-12')}>
              {`${t('purchase_page.agree')} `}
              <span
                className={s.underLine}
                onClick={onShowDocument}
              >
                {t('purchase_page.offers')}
              </span>
              {` ${t('purchase_page.end')}`}
            </p>
          </div>
        )}

        <Button
          onClick={onSubmit}
          disabled={!isConfirm}
        >
          <span className={clsx('semi-bold-16', s.button)}>{t('to_pay')}</span>
        </Button>
      </div>
    </>
  )
}
